<template>
    <div>
        <div class="col-md-4 col-sm-10">
        <router-link :to="{name: 'marker', params: {markerId: marker.id}}">
            <span>{{ getLocalizedProp(marker.name) }}</span>
        </router-link>
        <router-link class="glyphicon glyphicon-pencil clickable edit" aria-hidden="true"
            tag="span"
            :to="{ path: `/marker/${marker.id}/edit` }">
        </router-link>
        <confirm-modal @confirm="deleteMarker(marker)"
            class="trash-marker"
            :cancel-label="$t('cancel')"
            :confirm-label="$t('delete')">
            <span slot="trigger" class="glyphicon glyphicon-trash clickable edit" aria-hidden="true">
            </span>
            <div slot="content"><p>{{ $t('marker.delete_confirmation') }}</p>
            <div class="well">{{ getLocalizedProp(marker.name) }}</div>
            </div>
        </confirm-modal>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
        <span class="visible-sm-inline visible-xs">{{ $t('marker.targeted_groups') }}<span v-html="$t('spacing')"></span>:</span>
        <span > {{ joined_targeted_groups }}</span>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
        <span class="visible-sm-inline visible-xs">{{ $t('marker.start_date') }}<span v-html="$t('spacing')"></span>:</span>
        <date :value="marker.starts_at"></date>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
        <span class="visible-sm-inline visible-xs">{{ $t('marker.end_date') }}<span v-html="$t('spacing')"></span>:</span>
        <date :value="marker.ends_at"></date>
        </div>
        <div class="col-md-2 col-sm-12">
        {{marker.records_count}}
        <span class="visible-sm-inline visible-xs-inline"> {{ $tc('records.video', marker.records_count >= 2 ? 2 : 1) }}</span>
        </div>
    </div>
</template>

<script>
// Render a list of markers as a table

import ConfirmModal from '../generic/ConfirmModal.vue'

// locales in fallback order
const locales = ['en', 'fr', 'nl']

export default {
  props: ['marker'],
  components: {
    ConfirmModal
  },
  methods: {
    deleteMarker (marker) {
      this.$emit('trash', marker)
    },
    // FIXME: refactor / make this method re-usable
    // Retrieve a field translation in the current language
    getLocalizedProp (obj) {
      let locale = this.currentLocale
      if (obj[locale]) {
        return obj[locale]
      }
      for (let l of locales) {
        if (obj[l]) {
          return obj[l]
        }
      }
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    joined_targeted_groups () {
      if (this.marker.targeted_groups.length === 0) return this.$t('all')
      let groups = this.marker.targeted_groups.map(x => x.groups).flat()
      return groups.map(x => x.name).join(', ')
    }
  }
}
</script>
